exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#icon-back[data-v-03bfbbaa] {\n    /* position: absolute; */\n    /* top: 2rem; */\n    /* left: 2rem; */\n    cursor: pointer;\n    color: #2096F3;\n    width: 2rem;\n    transition: 0.4s;\n}\n#icon-back[data-v-03bfbbaa]:hover {\n    opacity: 0.7;\n    transition: 0.4s ease-in-out;\n}\n", ""]);

// exports
